import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { RhymeGeneratorForm } from "../components/RhymeGeneratorForm";
import { ProjectCard } from "../components/ProjectCard";
import { YoutubeConnectCard } from "../components/YoutubeConnectCard";
import { api } from "../lib/api";
import { toast } from "sonner";

const activeStatuses = ["pending", "script", "voiceover", "visuals", "assembly"];

export default function RhymesPage() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);

  const load = async () => {
    try {
      const res = await api.get("/projects");
      setProjects(res.data.filter((p) => p.kind === "song" && p.song_type === "rhyme"));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    load();
    const interval = setInterval(() => {
      setProjects((prev) => {
        if (prev.some((p) => activeStatuses.includes(p.status))) load();
        return prev;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleCreated = (id) => navigate(`/project/${id}`);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/projects/${id}`);
      setProjects((prev) => prev.filter((p) => p.id !== id));
      toast.success("Project deleted");
    } catch (e) {
      toast.error("Failed to delete project");
    }
  };

  return (
    <div className="min-h-screen">
      <Header onNewProject={() => window.scrollTo({ top: 0, behavior: "smooth" })} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-12">
        <YoutubeConnectCard slot="rhyme" label="Kids Rhymes" />
        <RhymeGeneratorForm onCreated={handleCreated} />

        <section>
          <div className="flex items-center justify-between mb-6">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-50">Your Rhymes &amp; Cartoons</h2>
          </div>
          {projects.length === 0 ? (
            <p data-testid="rhyme-empty-state" className="text-slate-500 text-sm">No rhymes yet. Create your first one above!</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {projects.map((p, idx) => (
                <div key={p.id} style={{ animationDelay: `${idx * 0.05}s` }} className="animate-in fade-in">
                  <ProjectCard project={p} onOpen={(id) => navigate(`/project/${id}`)} onDelete={handleDelete} />
                </div>
              ))}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}
